/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_FieldInputs */

const cs_ebr_diff_field = /** @type {(inputs: Ebr_Diff_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole`)
};

const en_ebr_diff_field = /** @type {(inputs: Ebr_Diff_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field`)
};

/**
* | output |
* | --- |
* | "Field" |
*
* @param {Ebr_Diff_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_field = /** @type {((inputs?: Ebr_Diff_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_field(inputs)
	return cs_ebr_diff_field(inputs)
});